import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import SpecificationItem from './components/SpecificationItem/SpecificationItem.js';

/**
 * @deprecated - use ProductDetailSpecification from the fun-products package instead
 */ const ProductDetailSpecification = ({ configuration , variant  })=>{
    const { getLabel  } = useIntl();
    const title = getLabel('products.detail.specifications.title');
    if (!configuration || !variant) {
        return null;
    }
    const items = configuration.map((config)=>/*#__PURE__*/ React.createElement(SpecificationItem, {
            config: config,
            variant: variant,
            key: config.labelKey
        })
    );
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: "legacy-product-detail-specification",
        "data-t": "product-detail-specification"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: "legacy-product-detail-specification__title"
    }, title), /*#__PURE__*/ React.createElement("dl", {
        className: "legacy-product-detail-specification__list"
    }, items));
};
var ProductDetailSpecification$1 = ProductDetailSpecification;

export { ProductDetailSpecification$1 as default };
//# sourceMappingURL=ProductDetailSpecification.js.map
